module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("My " + _vm._s(_vm.contact.assigment))]), _vm._v(" "), _c('div', {
    staticClass: "contact-info"
  }, [_c('app-image', {
    staticClass: "photo",
    attrs: {
      "imageUrl": _vm.contact.photo
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.contact.name))]), _vm._v(" "), _c('span', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_vm.userType()))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [(_vm.contact.phone) ? _c('a', {
    staticClass: "link-item",
    attrs: {
      "href": 'sms:' + _vm.contact.phone
    },
    on: {
      "click": function($event) {
        $event.stopPropagation(); {}
      }
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-message"
  }), _vm._v("Text")]) : _vm._e(), _vm._v(" "), (_vm.contact.phone) ? _c('a', {
    staticClass: "link-item",
    attrs: {
      "href": _vm.phone
    },
    on: {
      "click": function($event) {
        $event.stopPropagation(); {}
      }
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-phone-call"
  }), _vm._v("Call")]) : _vm._e(), _vm._v(" "), (_vm.contact.email) ? _c('a', {
    staticClass: "link-item",
    attrs: {
      "href": _vm.email
    },
    on: {
      "click": function($event) {
        $event.stopPropagation(); {}
      }
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-email"
  }), _vm._v("Email")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addToPhone.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-smartphone-download"
  }), _vm._v("Add to\n      phone")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.contact.reviewsUrl) ? _c('a', {
    staticClass: "link-item",
    attrs: {
      "href": _vm.contact.reviewsUrl
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-star"
  }), _vm._v("Reviews")]) : _vm._e(), _vm._v(" "), (_vm.contact.blogUrl) ? _c('a', {
    staticClass: "link-item",
    attrs: {
      "href": _vm.contact.blogUrl
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-article"
  }), _vm._v("Blog")]) : _vm._e(), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "about"
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-businessman"
  }), _vm._v("About me")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link-item",
    attrs: {
      "href": "recommendfriend"
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-users-three"
  }), _vm._v("Refer")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c1fa6dea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1fa6dea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/contact/contact.component.vue
// module id = 811
// module chunks = 0